//DcrList.jsx 
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const DcrList = () => {

  const location = useLocation();
  // console.log("Location in DcrList ", location);
  const authState = useSelector(state => state.authReducer);

  const [dcrs, setDcrs] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [fromPage, setFromPage] = useState(location.state.fromPage);
  const [bookId, setBookId] = useState(location.state.bookId);
  const [bookTitle, setBookTitle] = useState(location.state.bookTitle);
  const [ownerId, setOwnerId] = useState(location.state.ownerId);
  const [ownerName, setOwnerName] = useState(location.state.ownerName);

  const [selectedFlyerId, setSelectedFlyerId] = useState(null);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const fetchDcrs = useCallback(() => {
    const config = {
      url: "/dcr/mydcrs",
      method: "get",
      headers: { Authorization: authState.token },
      params: { bookId, ownerId }
    };

    fetchData(config, { showSuccessToast: false })
      .then(data => {
        // console.log("received data : ", data);
        if (data && Array.isArray(data.dcr)) {
          setDcrs(data.dcr);
        } else {
          console.error("Invalid response format: Dcrs not found in response!");
        }
      })
      .catch(error => {
        console.error('Error fetching Dcrs:', error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchDcrs();
  }, [authState.isLoggedIn, fetchDcrs]);

  //   useEffect(() => {
  //     console.log("Dcrs:", dcrs);
  // }, [dcrs]);


  const handleView = (dcrId) => {
    setSelectedFlyerId(prevId => (prevId === dcrId ? null : dcrId));
  };

  const handleComments = (id) => {
    setSelectedRecordId(id);
  };

  const handleCommentSave = (id) => {
    setSelectedRecordId(id);
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const sortedDcrs = [...dcrs].sort((a, b) => b.dcrName - a.dcrName);

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>BookShelf - Digital Co-Readers</h2>
      </div>
      <div className="my-2 mx-auto max-w-[700px] py-4">
        <div className="border border-gray-300 p-4 mt-4">
          <div className="flex justify-between items-center border-b border-b-gray-300  bg-purple-600">
            <div className='text-xl mt-1 mx-2 text-white w-7/10'>
              <p className='text-yellow-300' >You have {dcrs.length} Co-Readers</p>
              {bookTitle !== 'All' && <p className='text-xl mt-1 mx-2 text-white'>{bookTitle} </p>}
            </div>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <div>
              {dcrs.length === 0 ? (
                <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <span>No record found!!</span>
                </div>
              ) : (
                sortedDcrs.map((dcr, index) => (
                  <div key={dcr._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                    <div className='flex'>
                      <span className='font-medium'>{index + 1}. {dcr.dcrName}</span>
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(dcr._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                      <Tooltip text={"Edit this record"} position={"top"}>
                        <Link to={`/dcronthewall/${dcr._id}`} className='mr-4 text-green-600 cursor-pointer'>
                          <i className="fa-solid fa-pen"></i>
                        </Link>
                      </Tooltip>
                    </div>
                    <div className='whitespace-pre  text-blue-700'>{dcr.dcrName}</div>
                    {selectedFlyerId === dcr._id && (
                      <div className='bg-gray-200 text-black'>
                        <div>
                          <div>
                            <p><strong>Co-Reader:</strong> {dcr.dcrName}</p>
                            <p><strong>Date:</strong> {dcr.dateCreated}</p>
                            <p><strong>Is Allowed:</strong> {dcr.isAllowed ? "Yes" : "No"}</p>
                            <p><strong>Co-Reading Books:</strong></p>
                            <p>{dcr.bookTitle}</p>
                            <p><strong>#Read Alllowed:</strong> {dcr.noOfReadsAllowed}</p>
                            <p><strong>Current #Read:</strong> {dcr.currentNoOfReads}</p>
                          </div>
                          <div>
                            <p className='text-blue-500'><strong>Comments:</strong></p>
                            <div> 
                              {dcr.comments.map((comment, commentIndex) => (
                                <div key={commentIndex} className={commentIndex % 2 === 0 ? 'bg-blue-100' : ''}>
                                  <p><strong>{comment.commentBy}</strong></p>
                                  <p>{new Date(comment.date).toLocaleString()}</p>
                                  <p>{comment.comment}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )} 
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  )
}

export default DcrList;
